import React from "react";

import { useTranslation } from "react-i18next";

import ModalIndex from "@Modals/layout/index";

export default React.memo(function ModalDeleteMaterial({
  onCloseClicked,
  show,
  object,
  onDelete,
  isLoading,
}) {
  const { t } = useTranslation("beginEnd.protocol");

  return (
    <ModalIndex
      isOpen={show}
      isLoading={isLoading}
      onClickClose={onCloseClicked}
      buttonOptions={{
        click: onDelete,
        color: "green",
        title: t("Supprimer"),
      }}
      buttonCancelOptions={{
        click: onCloseClicked,
        color: "outlined",
        title: t("Annuler"),
      }}
    >
      <h3 className="arh-px-6 arh-font-poppins arh-text-2xl arh-font-semibold arh-text-darkColor">
        {t(`Êtes-vous sûr de vouloir supprimer`)} {t(object)}?
      </h3>
    </ModalIndex>
  );
});
